"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MultiSelectActionToolbarStyled = require("./MultiSelectActionToolbar-styled.js");
var _ActionButtonList = _interopRequireDefault(require("../ActionButtonList"));
var _helper = require("../../utils/helper");
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MultiSelectActionToolbar = function MultiSelectActionToolbar(_ref) {
  var items = _ref.items,
    actions = _ref.actions,
    clearSelectedItems = _ref.clearSelectedItems,
    userSession = _ref.userSession,
    handleQueryChange = _ref.handleQueryChange,
    itemBrowserState = _ref.itemBrowserState,
    getUserFolders = _ref.getUserFolders,
    menuLocationTitle = _ref.menuLocationTitle,
    queryResults = _ref.queryResults;
  var selectedFolder = (0, _helper.getSelectedFolder)(itemBrowserState);
  var getPaginationCount = function getPaginationCount() {
    var _queryResults$results;
    var start = queryResults.start,
      total = queryResults.total;
    var end = start + (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results = queryResults.results) === null || _queryResults$results === void 0 ? void 0 : _queryResults$results.length) - 1;
    if (start && end && total) {
      return "".concat(start, " - ").concat(end, " of ").concat(total, " in ").concat(menuLocationTitle);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbarStyled.StyledMultiSelectActionToolbar, null, queryResults && /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbarStyled.StyledH6, null, selectedFolder && !(items === null || items === void 0 ? void 0 : items.length) ? getPaginationCount() : selectedFolder && (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbarStyled.StyledLabelContainer, null, /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbarStyled.StyledLabel, null, "".concat(items === null || items === void 0 ? void 0 : items.length, " selected")), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    appearance: "transparent",
    color: "neutral",
    scale: "s",
    onClick: clearSelectedItems
  }, "Clear Selection")) : ""), (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/_react.default.createElement(_ActionButtonList.default, {
    actions: actions,
    showLabel: true,
    items: items,
    userSession: userSession,
    handleQueryChange: handleQueryChange,
    clearSelectedItems: clearSelectedItems,
    itemBrowserState: itemBrowserState,
    getUserFolders: getUserFolders,
    queryResults: queryResults
  }) : "");
};
var _default = MultiSelectActionToolbar;
exports.default = _default;